import ErrorAlert from "@/utility/ErrorAlert";
import http from "../axios/http-common";

async function create(data) {
  const response = await http
    .postData("/asesmen-awal-bayi-baru-lahir", data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function update(id, data) {
  const response = await http
    .putData(`/asesmen-awal-bayi-baru-lahir/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function getByRegister(register_id: string | number) {
  const response = await http
    .getData(`/register/${register_id}/asesmen-awal-bayi-baru-lahir`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function getByMotherRegister(motherReg: string | number) {
  const response = await http
    .getData(`/register/${motherReg}/bayi-asesmen`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function find(id: number) {
  const response = await http
    .getData(`/asesmen-awal-bayi-baru-lahir/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function destroy(id: number) {
  const response = await http
    .deleteData(`/asesmen-awal-bayi-baru-lahir/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function signDokter(id: number, data) {
  const response = await http
    .putData(`/asesmen-awal-bayi-baru-lahir/${id}/sign-dokter`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function signPpja(id: number, data) {
  const response = await http
    .putData(`/asesmen-awal-bayi-baru-lahir/${id}/sign-ppja`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

function printPdf(id) {
  window.open(
    `${http.getAPI()}/asesmen-awal-bayi-baru-lahir/${id}/pdf`,
    "_blank"
  );
}

export default {
  create,
  update,
  getByRegister,
  getByMotherRegister,
  find,
  destroy,
  signDokter,
  signPpja,
  printPdf
};
